import { Grid } from "antd";
import { useEffect, useState } from "react";

export default function useBreakpoint() {
  const screens = Grid.useBreakpoint();
  const [width, setWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200
  );
  const [height, setHeight] = useState(
    typeof window !== "undefined" ? window.innerHeight : 800
  );

  useEffect(() => {
    const onResize = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const isMobile = !screens.md;
  const isTablet = !!screens.md && !screens.lg;
  const isDesktop = !!screens.lg;

  return {
    ...screens,
    width,
    height,
    isMobile,
    isTablet,
    isDesktop,
  };
}
